import { render } from "./AssetType_Scenes.vue?vue&type=template&id=4e1a2dc6&ts=true"
import script from "./AssetType_Scenes.vue?vue&type=script&lang=ts"
export * from "./AssetType_Scenes.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__